import React from 'react';
export function AnnouncementBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-coral text-white py-3 px-4 text-center text-sm font-sans font-medium shadow-md" data-id="element-22">
      ⏰ PRECIO DE LANZAMIENTO $9.99 — Sube a $15,99 muy pronto →{' '}
      <a href="#comprar-final" className="underline font-bold hover:text-white/80 transition-colors" data-id="element-23">
        DESCARGAR AHORA
      </a>
    </div>;
}